import React from 'react';
import { Link } from 'react-router-dom';

import ScrollExpansionHero from '../../../components/blocks/ScrollExpansionHero';

const TRUST_CHIPS = ['Direct from FPOs', 'No middlemen', 'Transparent pricing', 'Traceable supply'];

function PostExpandContent() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center gap-8 text-center">
      <p className="text-base leading-relaxed text-green-50/90 sm:text-lg">
        Atharva connects Farmer Producer Organisations directly to bulk buyers. List aggregated
        stock, get discovered, fulfil orders end-to-end. No middlemen, transparent pricing,
        traceable supply.
      </p>

      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
        <Link
          to="/signup"
          className="group inline-flex items-center justify-center gap-2 rounded-xl bg-white px-7 py-3.5 text-base font-semibold text-green-900 shadow-xl shadow-green-950/40 transition-all duration-200 hover:-translate-y-0.5 hover:bg-green-50"
        >
          Sign up as an FPO
          <svg className="h-4 w-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
        <Link
          to="/signup"
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/30 bg-white/5 px-7 py-3.5 text-base font-semibold text-white backdrop-blur-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-white/50 hover:bg-white/10"
        >
          Sign up as a buyer
        </Link>
      </div>

      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-green-100/80 sm:text-sm">
        {TRUST_CHIPS.map((c) => (
          <span key={c} className="inline-flex items-center gap-1.5">
            <svg className="h-3.5 w-3.5 text-green-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
            {c}
          </span>
        ))}
      </div>
    </div>
  );
}

// Farmers-in-field photo for the centred media box; agriculture field as the bg.
// Swap HERO_MEDIA to a video later (mediaType="video") if you stage a real MP4
// at /videos/hero.mp4 — see public/videos/README.txt.
const HERO_MEDIA = '/farmers.jpg';
const HERO_BG = 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=2400&q=80';

export default function HeroSection() {
  return (
    <section id="hero" className="bg-green-950 text-white">
      <ScrollExpansionHero
        mediaType="image"
        mediaSrc={HERO_MEDIA}
        bgImageSrc={HERO_BG}
        title="FPO supply, buyer demand"
        date="Agri-Marketplace · India"
        scrollToExpand="Scroll to expand"
        textBlend={false}
      >
        <PostExpandContent />
      </ScrollExpansionHero>
    </section>
  );
}
